export class Config {
  static environment = process.env.NODE_ENV;
  static apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  static apiAccessKey = process.env.REACT_APP_API_ACCESS_KEY;
  static apiProxyUrl = process.env.REACT_APP_API_PROXY_URL;
}
